export default __webpack_public_path__ + "images/layout5.png";